import React from 'react';
import './About2.css';

const About2 = ({ top, bottom }) => {
  return (
    <section className="about2-section">
      <div className="about2-container">
        <div className="about2-cards">
          {top && (
            <div className="about2-card">
              <p className="about2-text" dangerouslySetInnerHTML={{ __html: top }}></p>
            </div>
          )}
          {bottom && (
            <div className="about2-card inverse">
              <p className="about2-text" dangerouslySetInnerHTML={{ __html: bottom }}></p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default About2;
